import React from 'react'
import { NavLink } from 'react-router-dom'
import BrowserIcons from '../assets/BrowserIcons'
import BrowserIconsLines from '../assets/BrowserIconsLines'
import DeviceImages from '../assets/DeviceImages'
import SiteIcons from '../assets/SiteIcons'
import styled from 'styled-components'
import Brightness from '../scripts/Brightness'

import RequirementsTabs from './RequirementsTabs'

const Requirements = (props) => {

  const osRequirements = props.match.params.os

  let ios = ''

  if (props.browserInfo[4] === 'iOS') {
    ios = 'ios'
  }

  let BrowserName = props.browserInfo[1]

  if (BrowserName === 'ie') {
    BrowserName = 'IE'
  }


  const BrowserVersion = props.browserInfo[2].slice(0,4)

  const ActiveButtonBorder = Brightness(props.themeStyles.mainColor, -0.4);

  const RequirementsButton = styled(NavLink)`
    background-color: rgba(0,0,0,0.4);
    color: ${props.themeStyles.buttonText};
    border: solid 1px rgba(0,0,0,0);

    &:hover {
      color: ${props.themeStyles.buttonText};
      background-color: rgba(0,0,0,0.7);
    }

    &.active {
      color: ${props.themeStyles.buttonText};
      background-color: ${props.themeStyles.mainColor};
      border: solid 1px ${ActiveButtonBorder};
    }
  `
  const RequirementsArea = styled.section`
    color: ${props.themeStyles.fontColor};
  `

  const SupportDescription = styled.section`
    color: ${props.themeStyles.fontColorLight};

    .notes {
      color: ${props.themeStyles.fontColorLight};
    }
  `

  const BrowserContainer = styled.section`
    border-bottom: solid 1px ${props.themeStyles.borderColor};
  `

  return (
    <div id="requirementsPage" className="sectionContainer">

      <BrowserContainer className="browserContainer">
        <h1>Your system's details</h1>
        <div className="browserDetsContainer">
          {props.browserInfo[0] === true &&
            <div className="browserDets supported">
              <SiteIcons icon="thumbsUp" />
              <span>Supported</span>
            </div>
          }
          {props.browserInfo[0] === false &&
            <div className="browserDets unsupported">
              <SiteIcons icon="thumbsDown" />
              <span>Unsupported</span>
            </div>
          }
          <div className="browserDets">
            <DeviceImages graphic={props.browserInfo[3]} />
            <span><span className={ios}>{props.browserInfo[4]}</span> {props.browserInfo[5]} - {props.browserInfo[3]}</span>
          </div>
          <div className="browserDets">
            <BrowserIconsLines browser={props.browserInfo[1]} />
            <span>{BrowserName} {BrowserVersion}</span>
          </div>
        </div>
      </BrowserContainer>

      <SupportDescription className="supportDescription">
        <div className="text">
          <h1>eLearning for the modern web</h1>
          <p>Our courses are optimized for the modern web. To keep user experience consistent and to continue advancing our course software capabilities, we only support modern HTML5 browsers. These browsers allow us to implement audio, animations, video and more without the need for third party plugins like Flash*. On supported browsers, our courses work on desktop computers as well as tablets.</p>
          <p className="notes">* Streaming video capabilities on some browsers may require Flash</p>
        </div>
        <div className="supportedBrowsers">
          <ul className="browsers">
            <li><div><BrowserIcons browser="ie" /><span>IE 11</span></div></li>
            <li><div><BrowserIcons browser="edge" /><span>Edge</span></div></li>
            <li><div><BrowserIcons browser="chrome" /><span>Chrome</span></div></li>
            <li><div><BrowserIcons browser="safari" /><span>Safari</span></div></li>
          </ul>
        </div>
      </SupportDescription>

      <RequirementsArea id="requirementsArea">
        <div id="requirementsTabs">
          <div className="requirementsNavigation">
            <RequirementsButton exact to="/requirements" className="requirementsButton" activeClassName="active">General</RequirementsButton>
            <RequirementsButton exact to="/requirements/windows" className="requirementsButton" activeClassName="active">Windows</RequirementsButton>
            <RequirementsButton exact to="/requirements/mac" className="requirementsButton" activeClassName="active">Mac</RequirementsButton>
            <RequirementsButton exact to="/requirements/tablets" className="requirementsButton" activeClassName="active">Tablets</RequirementsButton>
          </div>
          <RequirementsTabs osReqs={osRequirements} themeStyles={props.themeStyles} />
        </div>
      </RequirementsArea>

    </div>
  )

}

export default Requirements
